/**
 * Whether a list's next query string is the one it already shows, ignoring parameter order. A
 * Filter click with unchanged filters leaves the URL as it is, so nothing re-reads the list; the
 * log pages check this and reload instead.
 */
export function sameParams(current: URLSearchParams, next: Record<string, string>): boolean {
  const a = [...current.entries()].map(([k, v]) => `${k}=${v}`).sort();
  const b = Object.entries(next).map(([k, v]) => `${k}=${v}`).sort();
  return a.length === b.length && a.every((pair, i) => pair === b[i]);
}
